/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Headings_Pastupcoming1Inputs */

const id_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Sebelumnya / Mendatang`)
};

const ms_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jualan Lepas / Akan Datang`)
};

const da_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere / Kommende Udsalg`)
};

const de_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergangene / Bevorstehende Angebote`)
};

const en_us2_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past / Upcoming Sales`)
};

const es_es2_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebajas pasadas / próximas`)
};

const es_mx2_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promociones anteriores / próximas`)
};

const fil_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nakaraan / Paparating na Sale`)
};

const fr_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions passées / à venir`)
};

const it_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti passati / futuri`)
};

const hu_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korábbi / Közelgő akciók`)
};

const nl_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerdere / aankomende aanbiedingen`)
};

const no_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere / kommende salg`)
};

const pl_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie / nadchodzące promocje`)
};

const pt_br2_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções anteriores / futuras`)
};

const pt_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções anteriores / futuras`)
};

const ro_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduceri anterioare / viitoare`)
};

const fi_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aikaisemmat / tulevat alennukset`)
};

const sv_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidigare / kommande reor`)
};

const vi_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá trước đây / Sắp tới`)
};

const tr_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçmiş / Yaklaşan İndirimler`)
};

const cs_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minulé / Nadcházející slevy`)
};

const bg_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишни / Предстоящи промоции`)
};

const ru_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедшие / Предстоящие скидки`)
};

const uk_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минулі / Майбутні розпродажі`)
};

const ar_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخفيضات السابقة / القادمة`)
};

const hi_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली / आगामी सेल`)
};

const th_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดราคาในอดีต / กำลังจะมา`)
};

const ja_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去 / 今後のセール`)
};

const zh_cn2_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期 / 即将到来的促销`)
};

const zh_hant1_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`往期 / 即將到來的促銷`)
};

const ko_sales_headings_pastupcoming1 = /** @type {(inputs: Sales_Headings_Pastupcoming1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지난 / 예정 할인`)
};

/**
* | output |
* | --- |
* | "Past / Upcoming Sales" |
*
* @param {Sales_Headings_Pastupcoming1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_headings_pastupcoming1 = /** @type {((inputs?: Sales_Headings_Pastupcoming1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Headings_Pastupcoming1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_headings_pastupcoming1(inputs)
	if (locale === "ms") return ms_sales_headings_pastupcoming1(inputs)
	if (locale === "da") return da_sales_headings_pastupcoming1(inputs)
	if (locale === "de") return de_sales_headings_pastupcoming1(inputs)
	if (locale === "en-US") return en_us2_sales_headings_pastupcoming1(inputs)
	if (locale === "es-ES") return es_es2_sales_headings_pastupcoming1(inputs)
	if (locale === "es-MX") return es_mx2_sales_headings_pastupcoming1(inputs)
	if (locale === "fil") return fil_sales_headings_pastupcoming1(inputs)
	if (locale === "fr") return fr_sales_headings_pastupcoming1(inputs)
	if (locale === "it") return it_sales_headings_pastupcoming1(inputs)
	if (locale === "hu") return hu_sales_headings_pastupcoming1(inputs)
	if (locale === "nl") return nl_sales_headings_pastupcoming1(inputs)
	if (locale === "no") return no_sales_headings_pastupcoming1(inputs)
	if (locale === "pl") return pl_sales_headings_pastupcoming1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_headings_pastupcoming1(inputs)
	if (locale === "pt") return pt_sales_headings_pastupcoming1(inputs)
	if (locale === "ro") return ro_sales_headings_pastupcoming1(inputs)
	if (locale === "fi") return fi_sales_headings_pastupcoming1(inputs)
	if (locale === "sv") return sv_sales_headings_pastupcoming1(inputs)
	if (locale === "vi") return vi_sales_headings_pastupcoming1(inputs)
	if (locale === "tr") return tr_sales_headings_pastupcoming1(inputs)
	if (locale === "cs") return cs_sales_headings_pastupcoming1(inputs)
	if (locale === "bg") return bg_sales_headings_pastupcoming1(inputs)
	if (locale === "ru") return ru_sales_headings_pastupcoming1(inputs)
	if (locale === "uk") return uk_sales_headings_pastupcoming1(inputs)
	if (locale === "ar") return ar_sales_headings_pastupcoming1(inputs)
	if (locale === "hi") return hi_sales_headings_pastupcoming1(inputs)
	if (locale === "th") return th_sales_headings_pastupcoming1(inputs)
	if (locale === "ja") return ja_sales_headings_pastupcoming1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_headings_pastupcoming1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_headings_pastupcoming1(inputs)
	return ko_sales_headings_pastupcoming1(inputs)
});
export { sales_headings_pastupcoming1 as "sales.headings.pastUpcoming" }